import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudButtonModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { CreateMemedDialog } from './create-memed-dialog.component';

@NgModule({
	declarations: [CreateMemedDialog],
	imports: [CommonModule, TranslateModule.forChild(), FreudButtonModule],
	exports: [CreateMemedDialog],
	providers: [],
})
export class CreateMemedModalModule {}
